export const DbIcon = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 3.33301C14 4.43758 11.3137 5.33301 8 5.33301C4.68629 5.33301 2 4.43758 2 3.33301M14 3.33301C14 2.22844 11.3137 1.33301 8 1.33301C4.68629 1.33301 2 2.22844 2 3.33301M14 3.33301V12.6663C14 13.773 11.3333 14.6663 8 14.6663C4.66667 14.6663 2 13.773 2 12.6663V3.33301M14 7.99967C14 9.10634 11.3333 9.99967 8 9.99967C4.66667 9.99967 2 9.10634 2 7.99967"
			stroke="#475467"
			strokeWidth="1.33"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
